module.exports = [{
      plugin: require('../.yarn/cache/gatsby-plugin-anchor-links-npm-1.2.1-7db63a8548-373724406b.zip/node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-30},
    },{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-google-gtag-virtual-34a6899577/0/cache/gatsby-plugin-google-gtag-npm-3.8.0-a81127b65a-715345cc13.zip/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-YKTG0SMD8Q","G-HGZPBY9HV8"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
